app.factory('ewusModel', ['$rootScope', 'baseModel', 'ewusService',
    function($rootScope, baseModel, ewusService) {

        function EWUSModel() {
            this.updateRefundStatusForVisit = function(id) {
                ewusService.updateRefundStatusForVisit(id).then(
                    function (visit) {
                        $rootScope.$broadcast(Event.EWUS.UPDATE_REFUNDATION_STATUS_FOR_VISIT.SUCCESS, visit);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.EWUS.UPDATE_REFUNDATION_STATUS_FOR_VISIT.ERROR, error);
                    }
                )
            };

            this.updateEwusAuthenticationDataForDoctor = function(id, data) {
                return ewusService.updateEwusAuthenticationDataForDoctor(id, data).then(
                    function (ewusWrapper) {
                        $rootScope.$broadcast(Event.EWUS.UPDATE_EWUS_AUTHENTICATION_DATA.SUCCESS, ewusWrapper);
                        baseModel.broadcastOperationSucceeded();
                        return ewusWrapper;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.EWUS.UPDATE_EWUS_AUTHENTICATION_DATA.ERROR, error);
                    }
                )
            };

            this.getEwusAuthenticationDataForDoctor = function(id) {
                return ewusService.getEwusAuthenticationDataForDoctor(id).then(
                    function (ewusWrapper) {
                        $rootScope.$broadcast(Event.EWUS.GET_EWUS_AUTHENTICATION_DATA.SUCCESS, ewusWrapper);
                        return ewusWrapper;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.EWUS.GET_EWUS_AUTHENTICATION_DATA.ERROR, error);
                    }
                )
            };

        }

        return new EWUSModel();
    }
]);
